import { useOutletContext } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { TopPlayers } from '@sorare/gameplay/src/components/topPlayers/TopPlayers';
import type { Filters } from '@sorare/gameplay/src/components/topPlayers/TopPlayers/TopPlayersFilters/types';

import type { PageParams } from './__generated__/routeParams';

const TopPlayersPage = () => {
  const { fixture } = useTypedParams<PageParams>();
  const { fixture: fixtureFromOutletContext, filters } = useOutletContext<{
    fixture: string;
    filters: Filters;
  }>();

  return (
    <TopPlayers
      fixture={fixtureFromOutletContext || fixture}
      filters={filters}
    />
  );
};

export default TopPlayersPage;
